import { render } from "./SwitchNotice.vue?vue&type=template&id=e2d0297e&scoped=true"
import script from "./SwitchNotice.vue?vue&type=script&lang=js"
export * from "./SwitchNotice.vue?vue&type=script&lang=js"

import "./SwitchNotice.vue?vue&type=style&index=0&id=e2d0297e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2d0297e"]])

export default __exports__